module.exports = __webpack_public_path__ + "img/splash.82a43d9c.png";